import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../../types";
import { FormAiAgentsSendDM } from "./FormAiAgentsSendDM";
import type { HistoryDetailViewSendDMProps } from "./HistoryDetailViewSendDM";
import { HistoryDetailViewSendDM } from "./HistoryDetailViewSendDM";
import { useIsAiWorkflowsSendDmEnabled } from "./useIsAiWorkflowsSendDmEnabled";

export const sendDM: Readonly<ActionOption<HistoryDetailViewSendDMProps>> = {
  label: t("settings.workflows.form.actions.ai_agents_send_dm"),
  textLabel: t("settings.workflows.form.actions.ai_agents_send_dm"),
  value: "ai_agents_send_dm",
  group: t("settings.workflows.form.action_groups.ai_agents"),
  leftAddon: <Icon type="16-ai-send-dm" size={16} className="!h-4 !w-4" />,
  formComponent: FormAiAgentsSendDM,
  viewComponent: null,
  historyDetailViewComponent: HistoryDetailViewSendDM,
  icon: "chat",
  isApplicableToMembersOnly: false,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
  released: useIsAiWorkflowsSendDmEnabled,
} as const;
